import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const AnalyticsIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M30.608 4.174h-4.174c-0.767 0-1.391 0.624-1.391 1.391v20.869c0 0.767 0.624 1.391 1.391 1.391h4.174c0.767 0 1.391-0.624 1.391-1.391v-20.869c0-0.767-0.624-1.391-1.391-1.391zM22.261 13.913h-4.174c-0.767 0-1.391 0.624-1.391 1.391v11.13c0 0.767 0.624 1.391 1.391 1.391h4.174c0.767 0 1.391-0.624 1.391-1.391v-11.13c0-0.767-0.624-1.391-1.391-1.391zM13.913 9.739h-4.174c-0.767 0-1.391 0.624-1.391 1.391v15.304c0 0.767 0.624 1.391 1.391 1.391h4.174c0.767 0 1.391-0.624 1.391-1.391v-15.304c0-0.767-0.624-1.391-1.391-1.391zM6.957 19.478v6.956c0 0.767-0.624 1.391-1.391 1.391h-4.174c-0.767 0-1.391-0.624-1.391-1.391v-6.956c0-0.767 0.624-1.391 1.391-1.391h4.174c0.767 0 1.391 0.624 1.391 1.391z"
  }));
};
export default /*#__PURE__*/memo(AnalyticsIcon);